module.exports = __webpack_public_path__ + "img/recharge.30826a90.png";